/**
 * Sentry warning used when a student impact query has more rows than `usePagedQuery` will fetch.
 */
export const STUDENT_IMPACT_MESSAGE = 'Student impact query exceeded the page limit';

/**
 * Resolve the effective number of students impacted by a project or event.
 *
 * steward-api computes `actualStudents` (the creator's evaluation count when it
 * qualifies, otherwise the activity's own `students`). When the API does not
 * provide the field yet (`undefined`), fall back to `students`.
 *
 * @param {Object} item - Lore model (`{ data: {...} }`) or plain metrics item
 * @returns {number|null} the student count, or null when not a number >= 0
 */
export function getActualStudents(item) {
  const d = item?.data ?? item;

  if (!d) {
    return null;
  }

  const value = d.actualStudents !== undefined ? d.actualStudents : d.students;

  return typeof value === 'number' && value >= 0 ? value : null;
}

/**
 * Sum the effective student counts of a list of items, skipping items without a count.
 *
 * @param {Object[]} items - Lore models or plain metrics items
 * @param {Function} [filterFn] - optional predicate; items it rejects are skipped
 * @returns {number}
 */
export function sumActualStudents(items, filterFn = () => true) {
  return (items || []).reduce(function(result, item) {
    if (!filterFn(item)) {
      return result;
    }

    const students = getActualStudents(item);

    return students === null ? result : result + students;
  }, 0);
}
